import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  TextField,
  useTheme,
  Grid2,
  FormHelperText,
} from "@mui/material";
import * as React from "react";
import { IoMdClose } from "react-icons/io";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useDispatch } from "store";
import { useRejectKeyRiskMutation } from "store/slices/apis/keyRiskSlice";
import * as Yup from "yup";
import { Formik } from "formik";
import { useRejectKeySafetyMutation } from "store/slices/apis/keySafetySlice";

export default function RejectSafetyComponent(props) {
  const { open, cancel, rowData, keys, refetch } = props;
  const theme = useTheme();
  const [rejectKeySafety] = useRejectKeySafetyMutation();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    comment: "",
  });

  const openNotification = async (msg, type = "error") => {
    await dispatch(
      openSnackbar({
        open: true,
        message: msg,
        variant: "alert",
        alert: {
          color: type,
        },
        close: false,
      })
    );

    setTimeout(() => dispatch(closeSnackbar()), 3000);
  };

  const handleSubmit = async (values) => {
    if (keys === "safety") {
      let reqBody = {
        comment: values?.comment?.trim(),
      };
      try {
        const response = await rejectKeySafety({
          id: rowData?.safety_id,
          body: { ...reqBody },
        });
        if (response?.data?.status === "success") {
          openNotification(
            response?.data?.message || "Safety approved successfully",
            "success"
          );
          cancel();
          refetch();
        } else {
          openNotification("Error in reject safety");
        }
      } catch (error) {
        openNotification(error?.error, "error");
      }
    }
  };

  const validationSchema = Yup.object({
    comment: Yup.string().required("Comment field is required."),
  });

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={cancel}
        disableEnforceFocus
        disableRestoreFocus
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          sx={{
            fontWeight: 500,
            fontSize: "20px",
            color: "#252525",
            paddingBottom: 0,
          }}
          id="draggable-dialog-title"
        >
          Reject
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={cancel}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <IoMdClose style={{ fontSize: "20px" }} />
        </IconButton>
        <DialogContent>
          <Formik
            initialValues={formData}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              setTouched,
            }) => (
              <form onSubmit={handleSubmit}>
                <Grid2 size={12}>
                  <DialogContentText
                    sx={{
                      fontWeight: 400,
                      fontSize: "16px",
                      color: "#474747",
                      marginBottom: "20px",
                    }}
                  >
                    Are you sure you want to Reject this safety? This action is
                    permanent.
                  </DialogContentText>
                  <DialogContentText
                    sx={{
                      fontWeight: 400,
                      fontSize: "16px",
                      color: "#474747",
                      marginBottom: "20px",
                      minWidth: "400px",
                    }}
                  >
                    <TextField
                      id="outlined-multiline-static"
                      label="Comment"
                      name="comment"
                      value={values?.comment}
                      onChange={handleChange}
                      multiline
                      fullWidth
                      onBlur={() => setTouched({ ...touched, comment: true })}
                      slotProps={{ inputLabel: { shrink: true } }}
                      variant="filled"
                      sx={{
                        "& .MuiInputLabel-root.Mui-focused": {
                          color: "#696969",
                          fontSize: "14px",
                        },
                      }}
                    />
                    {touched?.comment && errors?.comment && (
                      <FormHelperText
                        sx={{ color: "#C52A1A", fontSize: "12px" }}
                      >{`${errors?.comment}`}</FormHelperText>
                    )}
                  </DialogContentText>
                </Grid2>
                <Grid2 size={12}>
                  <DialogActions>
                    <Button
                      variant="outlined"
                      onClick={cancel}
                      sx={{
                        color: `${theme?.customSettings?.themeColor}`,
                        fontSize: "16px",
                        fontWeight: "500",
                        textTransform: "none",
                        border: `1px solid ${theme?.customSettings?.themeColor}`,
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      type="submit"
                      sx={{
                        backgroundColor: "#C52A1A",
                        color: "#fff",
                        fontSize: "16px",
                        fontWeight: "500",
                        textTransform: "none",
                      }}
                    >
                      Reject
                    </Button>
                  </DialogActions>
                </Grid2>
              </form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
